import { Icon } from "@iconify/react";
import { Col, Row, Space, Typography } from "antd";
import { ReactNode, useState } from "react";
import styles from "../../Modules/ContractManagement/SPA/SPA.module.scss";
import { DataTable } from "../DataTable/DataTable";
import { WrapperCard } from "../WrapperCard/WrapperCard";
import { map } from "lodash";

export const SpaReviewForm = ({
  cost,
  getItemText,
  viewDocument,
  props,
  step1Function,
  step2Function,
  docsList,
  stepAdditionalDocFunction,
  stepBudgetFunction,
  oneCenterEnable,
  stepOneStopFunction,
  stepApproverFunction,
  sortedWatchers,
  stepWatcherFunction,
  subsidiaryName,
  selectedPoints,
  selectedAuthority,
}: any) => {
  const formattedValue = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(parseFloat(cost));
  const updatedReviewers = (props?.values?.reviewers || []).filter((r: any) => r && "routingOrder" in r);
  const apcSecretariat = (props?.values?.reviewers || []).filter(
    (designation: any) => designation.designation === "APC SECRETARIAT"
  );
  const apcMembers = (props?.values?.reviewers || []).filter(
    (designation: any) => designation.designation === "APC MEMBER"
  );
  const airportManager = (props?.values?.reviewers || []).filter(
    (designation: any) => designation.designation === "AIRPORT MANAGER"
  );
  const filteredWatchers = sortedWatchers
    .filter((item: any, i: any) => item.role !== "R1")
    .filter((item: any) => item.userName && item.userEmail);
  const isAirportManager = props.values.approvalAuthority === "airportManager";
  const excludedAuthorities = ["MD/GCEO", "GCFO/GCOO", "HeadofSubsidiary"];
  const isExcludedAuthority = excludedAuthorities.includes(selectedAuthority);
  return (
    <>
      <Row style={{ marginBottom: styles.whitespace3 }}>
        <Col
          span={24}
          style={{ marginBottom: styles.whitespace3 }}
        >
          <WrapperCard
            title="Project Information"
            smallHeader
            action={
              <Icon
                icon="carbon:edit"
                style={{
                  color: styles.strawberry,
                  cursor: "pointer",
                  fontSize: 20,
                  verticalAlign: "middle",
                }}
                onClick={() => {
                  step1Function();
                }}
              />
            }
          >
            <Row>
              {" "}
              <Col
                className="content-wrap"
                xs={24}
                md={24}
              >
                {getItemText("Project Name", props?.values?.projectTitle)}
              </Col>
              <Col
                className="content-wrap"
                xs={24}
                md={24}
              >
                {getItemText("Budget", props?.values?.budgetDrop || props?.values?.budget)}
              </Col>
              <Col
                className="content-wrap"
                xs={24}
                md={24}
              >
                {getItemText("SPA Types", props?.values?.paperDrop || props?.values?.awardAndStrategyPaper)}
              </Col>
              <Col
                xs={24}
                md={24}
                className="content-wrap"
              >
                {getItemText("Project Summary", props?.values?.projectSummary)}
              </Col>
              <Row gutter={[16, 16]}>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText(
                    "Budget Amount/Pre-Tender Estimate (PTE)",
                    props?.values?.currencyCode + " " + (props?.values?.totalCost || formattedValue)
                  )}
                </Col>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText("Subsidiary/Division", subsidiaryName)}
                </Col>
                <Col
                  xs={24}
                  md={8}
                >
                  {getItemText("Cost Centre", props?.values?.division)}
                </Col>
              </Row>
              <Row>
                <div style={{ width: "100%" }}>
                  <h3 style={{ marginBottom: "15px" }}>A. Information on Procurement Process</h3>
                  {selectedPoints === "1a" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1a. Direct Appointment (Based on Permissible Criteria) - OEM/Sole – The procurement of services,
                      goods or works through OEM, sole Agency proprietorship, sole distributorship and the likes.
                    </div>
                  )}
                  {selectedPoints === "1b" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1b. Direct Appointment (Based on Permissible Criteria) - Wholly Owned Subsidiary/Inter Companies –
                      The procurement of works, services and supplies from wholly owned subsidiaries/intercompanies.
                    </div>
                  )}
                  {selectedPoints === "1c" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1c. Direct Appointment (Based on Permissible Criteria) - Government Sanctioned Rate – The
                      Procurement of services from any Government Agencies or any Government sanctioned bodies which is
                      unavoidable for purpose of certification or anything that is relevant to ensure business
                      continuity of the organization
                    </div>
                  )}

                  {selectedPoints === "1d" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1d. Direct Appointment (Based on Permissible Criteria) - Emergency cases on Operation Critical
                      nature- The procurement of services and goods in emergency cases. Specifically, the term
                      ‘Emergency’ shall be confined to a situation where immediate, in-situ and impromptu attention and
                      execution are a mission critical in the even that a slight delay will may discontinue or may
                      severely disrupt the operational functions of the business entity, in general and the airport, in
                      particular.
                    </div>
                  )}
                  {selectedPoints === "1e" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1e. Direct Appointment (Based on Permissible Criteria) - Specialist Consultancy Services - These
                      services involve providing specific, unique and strategic expertise tailored to meet the
                      specialized needs including but not limited to procurement solutions, legal advice, human
                      resources, tax consultancy, and similar fields. The focus is on delivering expert support that
                      caters to the complexities of niche sectors.
                    </div>
                  )}
                  {selectedPoints === "1f" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1f. Direct Appointment (Based on Permissible Criteria) - Continuation of Contract with approved
                      Vendor to another Budget Owner - A different budget owner appoints the same contractor or service
                      provider who is currently engaged under an existing contract, to carry out equivalent works or
                      services that fall within the scope or "boundary of that existing contract such as location, scope
                      of work, etc, subject to the following conditions:
                      <ul style={{ marginTop: "4px", paddingLeft: "20px", listStyle: "none" }}>
                        <li>● The main contract must have been competitively tendered</li>
                        <li>
                          ● The extension is only applicable within six (6) months from the commencement date of the
                          main contract.
                        </li>
                        <li>● The extension is allowed once only to another Budget Owner</li>
                      </ul>
                    </div>
                  )}
                  {selectedPoints === "1g" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1g. Direct Appointment (Based on Permissible Criteria) - Corporate Social Responsibility (CSR)
                      Vendors - Selected primary to support an organization's CSR initiatives. Their appointment is
                      based on their ability to contribute positively to social, environmental or community goals
                      aligned with the organization's CSR commitments.
                    </div>
                  )}
                  {selectedPoints === "1h" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>
                      1h. Direct Appointment (Based on Permissible Criteria) - Award of Contract Under Panel Vendor -
                      Where vendors have been pre-qualified under an established panel or framework agreement.
                    </div>
                  )}
                  {selectedPoints === "1i" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>1i. Quotation Invitation (Offline)</div>
                  )}
                  {selectedPoints === "2" && <div style={{ marginBottom: "30px", color: "black" }}>2. Open Tender</div>}
                  {selectedPoints === "3" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>3. Tender by Invitation</div>
                  )}
                  {selectedPoints === "4" && (
                    <div style={{ marginBottom: "30px", color: "black" }}>4. Variation order / Extension of time</div>
                  )}
                </div>

                <div style={{ width: "100%" }}>
                  <h3 style={{ lineHeight: 1 }}>
                    B. Summary of the Procurement (e.g Background, Evaluation & Justification){" "}
                  </h3>
                  <div
                    className="content-wrap"
                    style={{ overflowX: "auto" }}
                  >
                    {getItemText("", props?.values?.procurementSummary)}
                  </div>
                </div>

                <div style={{ width: "100%" }}>
                  <h3 style={{ marginTop: "10px" }}>C. Recommendation</h3>
                  <h4 style={{ fontWeight: 500 }}>Recommended Bidder/Vendor</h4>
                  <div
                    className="content-wrap"
                    style={{ marginTop: "-10px" }}
                  >
                    {getItemText("", props?.values?.recommendedVendor)}
                  </div>
                  <h4 style={{ fontWeight: 500, lineHeight: 1 }}>Proposed Contract Value</h4>
                  <div className="content-wrap">{getItemText("", props?.values?.contractValue)}</div>
                  <h4 style={{ fontWeight: 500, lineHeight: 1 }}>Proposed Contract Period</h4>
                  <div className="content-wrap">{getItemText("", props?.values?.contractPeriod)}</div>
                </div>
              </Row>
            </Row>
          </WrapperCard>
        </Col>
        <Col
          span={24}
          style={{ marginBottom: styles.whitespace3 }}
        >
          <Space size="large">
            <Typography.Title
              level={4}
              style={{ marginBottom: styles.whitesapce3 }}
            >
              Project Documents
            </Typography.Title>
            <Icon
              icon="carbon:edit"
              style={{
                color: styles.strawberry,
                cursor: "pointer",
                fontSize: 20,
                verticalAlign: "middle",
              }}
              onClick={() => {
                step2Function();
              }}
            />
          </Space>
          {docsList?.map((file: any, index: any) => (
            <Col
              span={24}
              style={{ display: "flex", alignItems: "center" }}
              key={`${index}${file?.name}`}
            >
              <Typography.Text key={index}>
                <Space>
                  <Icon
                    icon="clarity:success-standard-solid"
                    style={{
                      color: styles.secondaryGreen,
                      verticalAlign: "middle",
                    }}
                  />
                  {file?.name || file?.documentName}
                </Space>
              </Typography.Text>
              <Icon
                icon="ic:outline-remove-red-eye"
                inline
                fontSize={24}
                className="doc-icon-secondary"
                cursor="pointer"
                style={{
                  marginLeft: 16,
                  marginRight: 8,
                }}
                onClick={() => viewDocument(file)}
              />
            </Col>
          ))}
        </Col>
        <Col
          span={24}
          style={{ marginBottom: styles.whitespace3 }}
        >
          <Space size="large">
            <Typography.Title
              level={4}
              style={{ marginBottom: styles.whitesapce3 }}
            >
              Additional Document Details
            </Typography.Title>
            <Icon
              icon="carbon:edit"
              style={{
                color: styles.strawberry,
                cursor: "pointer",
                fontSize: 20,
                verticalAlign: "middle",
              }}
              onClick={() => {
                stepAdditionalDocFunction();
              }}
            />
          </Space>
          {props?.values?.documentLinkDetails && (
            <>
              {props.values.documentLinkDetails.length > 0 ? (
                props.values.documentLinkDetails.map((doc: any, index: number) => (
                  <Row
                    key={index}
                    gutter={[16, 8]}
                    style={{ marginBottom: 8 }}
                  >
                    <Col span={6}>
                      <Typography.Title level={5}>Document Name</Typography.Title>
                      <Typography.Text>{doc?.name || "-"}</Typography.Text>
                    </Col>
                    <Col span={18}>
                      <Typography.Title level={5}>Document Link</Typography.Title>
                      {doc?.url ? (
                        <Typography.Link
                          href={doc.url}
                          target="_blank"
                        >
                          {doc.url}
                        </Typography.Link>
                      ) : (
                        <Typography.Text>-</Typography.Text>
                      )}
                    </Col>
                  </Row>
                ))
              ) : (
                <Row>
                  <Col span={24}>
                    <Typography.Text>-</Typography.Text>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Col>
      </Row>
      {
        <>
          <Col
            span={24}
            style={{ marginBottom: styles.whitespace3 }}
          >
            <WrapperCard
              title=" Budget Manager"
              smallHeader
              action={
                <Icon
                  icon="carbon:edit"
                  style={{
                    color: styles.strawberry,
                    cursor: "pointer",
                    fontSize: 20,
                    verticalAlign: "middle",
                  }}
                  onClick={() => {
                    stepBudgetFunction();
                  }}
                />
              }
            >
              <Col span={24}>
                <DataTable
                  height={400}
                  multiSelect={false}
                  tableData={map(props?.values?.signers, (signers: any, index: any) => ({
                    ...signers,
                    routingOrder: (index + 1).toString(),
                  }))}
                  columns={[
                    {
                      key: "designation",
                      dataIndex: "designation",
                      title: "Designation",
                    },
                    {
                      key: "name",
                      dataIndex: "name",
                      title: "Name",
                    },
                    {
                      key: "email",
                      dataIndex: "email",
                      title: "Email Address",
                    },
                    {
                      key: "division",
                      dataIndex: "division",
                      title: "Cost Centre",
                    },
                    {
                      key: "routingOrder",
                      dataIndex: "routingOrder",
                      title: "Approving Order",
                    },
                  ]}
                  showTopBar={false}
                />
              </Col>
            </WrapperCard>
          </Col>
        </>
      }

      {oneCenterEnable && props?.values?.oneCenter?.length > 0 && (
        <Col
          span={24}
          style={{ marginBottom: styles.whitespace3 }}
        >
          <WrapperCard
            title="Secretariat, PCD"
            smallHeader
            action={
              props?.values?.oneCenter?.length > 2 ? (
                <Icon
                  icon="carbon:edit"
                  style={{
                    color: styles.strawberry,
                    cursor: "pointer",
                    fontSize: 20,
                    verticalAlign: "middle",
                  }}
                  onClick={() => {
                    stepOneStopFunction();
                  }}
                />
              ) : (
                <></>
              )
            }
          >
            <Col span={24}>
              <DataTable
                height={
                  props?.values?.reviewers?.length * 40 + 100 < 400 ? props?.values?.reviewers?.length * 80 + 100 : 400
                }
                multiSelect={false}
                tableData={map(props?.values?.oneCenter, (oneCenter) => ({
                  ...oneCenter,
                  routingOrder: 2,
                }))}
                columns={[
                  {
                    key: "designation",
                    dataIndex: "designation",
                    title: "Designation",
                  },
                  {
                    key: "name",
                    dataIndex: "name",
                    title: "Name",
                  },
                  {
                    key: "email",
                    dataIndex: "email",
                    title: "Email Address",
                  },

                  {
                    key: "routingOrder",
                    dataIndex: "routingOrder",
                    title: "Approving Order",
                  },
                ]}
                showTopBar={false}
              />
            </Col>
          </WrapperCard>
        </Col>
      )}
      <Col
        span={24}
        style={{ marginBottom: styles.whitespace3 }}
      >
        {isAirportManager && !isExcludedAuthority ? (
          <>
            <WrapperCard
              title="APC Secretariat"
              smallHeader
              action={
                <Icon
                  icon="carbon:edit"
                  style={{
                    color: styles.strawberry,
                    cursor: "pointer",
                    fontSize: 20,
                    verticalAlign: "middle",
                  }}
                  onClick={() => stepApproverFunction()}
                />
              }
            >
              <Col span={24}>
                <DataTable
                  height={
                    props?.values?.reviewers?.length * 40 + 100 < 400
                      ? props?.values?.reviewers?.length * 80 + 100
                      : 400
                  }
                  multiSelect={false}
                  tableData={apcSecretariat?.map((reviewer: any, index: any) => ({
                    ...reviewer,
                  }))}
                  columns={[
                    {
                      key: "designation",
                      dataIndex: "designation",
                      title: "Designation",
                    },
                    {
                      key: "name",
                      dataIndex: "name",
                      title: "Name",
                    },
                    {
                      key: "email",
                      dataIndex: "email",
                      title: "Email Address",
                    },
                    {
                      key: "routingOrder",
                      dataIndex: "routingOrder",
                      title: "Approving Order",
                    },
                  ]}
                  showTopBar={false}
                />
              </Col>
            </WrapperCard>
            <div style={{ marginTop: 25 }}>
              <WrapperCard
                title="APC Memmbers"
                smallHeader
                action={
                  <Icon
                    icon="carbon:edit"
                    style={{
                      color: styles.strawberry,
                      cursor: "pointer",
                      fontSize: 20,
                      verticalAlign: "middle",
                    }}
                    onClick={() => stepApproverFunction()}
                  />
                }
              >
                <Col span={24}>
                  <DataTable
                    height={
                      props?.values?.reviewers?.length * 40 + 100 < 400
                        ? props?.values?.reviewers?.length * 80 + 100
                        : 400
                    }
                    multiSelect={false}
                    tableData={apcMembers?.map((reviewer: any, index: any) => ({
                      ...reviewer,
                    }))}
                    columns={[
                      {
                        key: "designation",
                        dataIndex: "designation",
                        title: "Designation",
                      },
                      {
                        key: "name",
                        dataIndex: "name",
                        title: "Name",
                      },
                      {
                        key: "email",
                        dataIndex: "email",
                        title: "Email Address",
                      },
                      {
                        key: "routingOrder",
                        dataIndex: "routingOrder",
                        title: "Approving Order",
                      },
                    ]}
                    showTopBar={false}
                  />
                </Col>
              </WrapperCard>
            </div>
            <div style={{ marginTop: 25 }}>
              <WrapperCard
                title="Airport Manager"
                smallHeader
                action={
                  <Icon
                    icon="carbon:edit"
                    style={{
                      color: styles.strawberry,
                      cursor: "pointer",
                      fontSize: 20,
                      verticalAlign: "middle",
                    }}
                    onClick={() => stepApproverFunction()}
                  />
                }
              >
                <Col span={24}>
                  <DataTable
                    height={
                      props?.values?.reviewers?.length * 40 + 100 < 400
                        ? props?.values?.reviewers?.length * 80 + 100
                        : 400
                    }
                    multiSelect={false}
                    tableData={airportManager?.map((reviewer: any, index: any) => ({
                      ...reviewer,
                    }))}
                    columns={[
                      {
                        key: "designation",
                        dataIndex: "designation",
                        title: "Designation",
                      },
                      {
                        key: "name",
                        dataIndex: "name",
                        title: "Name",
                      },
                      {
                        key: "email",
                        dataIndex: "email",
                        title: "Email Address",
                      },
                      {
                        key: "routingOrder",
                        dataIndex: "routingOrder",
                        title: "Approving Order",
                      },
                    ]}
                    showTopBar={false}
                  />
                </Col>
              </WrapperCard>
            </div>
          </>
        ) : (
          <>
            <WrapperCard
              title="Approvers"
              smallHeader
              action={
                <Icon
                  icon="carbon:edit"
                  style={{
                    color: styles.strawberry,
                    cursor: "pointer",
                    fontSize: 20,
                    verticalAlign: "middle",
                  }}
                  onClick={() => stepApproverFunction()}
                />
              }
            >
              <Col span={24}>
                <DataTable
                  height={
                    props?.values?.reviewers?.length * 40 + 100 < 400
                      ? props?.values?.reviewers?.length * 80 + 100
                      : 400
                  }
                  multiSelect={false}
                  tableData={updatedReviewers?.map((reviewer: any, index: any) => ({
                    ...reviewer,
                  }))}
                  columns={[
                    {
                      key: "designation",
                      dataIndex: "designation",
                      title: "Designation",
                    },
                    {
                      key: "name",
                      dataIndex: "name",
                      title: "Name",
                    },
                    {
                      key: "email",
                      dataIndex: "email",
                      title: "Email Address",
                    },
                    {
                      key: "routingOrder",
                      dataIndex: "routingOrder",
                      title: "Approving Order",
                    },
                  ]}
                  showTopBar={false}
                />
              </Col>
            </WrapperCard>
          </>
        )}
      </Col>
      <Col
        span={24}
        style={{ marginBottom: styles.whitespace3 }}
      >
        <WrapperCard
          title="Watchers List"
          smallHeader
          action={
            <Icon
              icon="carbon:edit"
              style={{
                color: styles.strawberry,
                cursor: "pointer",
                fontSize: 20,
                verticalAlign: "middle",
              }}
              onClick={() => stepWatcherFunction()}
            />
          }
        >
          <Col span={24}>
            <DataTable
              height={
                props?.values?.watchers?.length * 40 + 100 < 400 ? props?.values?.watchers?.length * 80 + 100 : 400
              }
              multiSelect={false}
              tableData={map(filteredWatchers, (watchers) => ({
                ...watchers,
              }))}
              columns={[
                {
                  key: "role",
                  dataIndex: "role",
                  title: "Reviewer",
                  render: (value: any) => {
                    const displayValue = value === "PCD" ? "PCD" : value;
                    return displayValue || <Typography.Text disabled>-</Typography.Text>;
                  },
                },
                {
                  key: "userName",
                  dataIndex: "userName",
                  title: "Name",
                  render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                },
                {
                  key: "userEmail",
                  dataIndex: "userEmail",
                  title: "Email Address",
                  render: (value: any) => value || <Typography.Text disabled>-</Typography.Text>,
                },
              ]}
              showTopBar={false}
            />
          </Col>
        </WrapperCard>
      </Col>
    </>
  );
};
